import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        // Neutrales Grau statt Primärfarb-Tönung: bg-primary/10 färbte die
        // Platzhalter hell bläulich bzw. im Dark navy — ausdrücklich unerwünscht.
        "animate-pulse rounded-md bg-slate-200/70 dark:bg-white/[0.06]",
        className,
      )}
      {...props}
    />
  )
}

export { Skeleton }
